import { ResourceLanguage } from "i18next";

const ptBrTranslations: ResourceLanguage = {
    translations: {
        // Titles
        importSchoolHours: "importação das horas letivas",
        attachFile: "Importar Arquivos",
        selectTemplate: "1. Selecione o tipo de importação",
        attachFileLabel: "2. Anexe seu arquivo",
        onlyOneFile:
            "Se precisar de um template para ser usado como modelo, faça o download abaixo.",
        nextStep: "Caso já o tenha, siga para a etapa 1.",
        observations: "3. Observações (opcional)",
        useTemplateValid:
            "utilize o template acima como guia de formato válido (é permitido somente arquivos .xlsx).",
        uploadSuccessful: "upload concluído",
        trackFileStatus:
            "Acompanhe o status do arquivo ou realize novo upload.",
        onlyFilesExtensions:
            "Não é possível fazer o upload do arquivo selecionado. É aceito somente arquivos com extensão .xlsx",
        onlyFilesExtensionsPDF:
            "Não é possível fazer o upload do arquivo selecionado. É aceito somente arquivos com extensão .pdf",
        dropFiles: "SOLTE OS ARQUIVOS AQUI",
        unsupportedfFile: "arquivo não suportado",
        dragFile: "Arraste ou selecione o seu arquivo",
        selectFile: "Selecionar arquivo",
        uploadInformation:
            "Insira data de upload ou informações que sejam necessárias.",
        noFileSelected:
            "Faça o upload de um arquivo por vez no formato xlsx ou xls.",
        pleaseSelectAnotherImport:
            "Por favor, selecione outro tipo de importação.",
        invalidTemplate: "Template inválido",
        tableEmpty: "Nenhum registro encontrado",
        validityPeriod: "Período de vigência",
        operationSuccess: "Salvo com sucesso.",
        operationFailure:
            "Erro, entre em contato com o administrador do sistema.",
        saveFailureTitle: "Falha ao salvar",
        operationFailureTitle: "Falha na operação",
        operationFailureText:
            "Entre em contato com o administrador do sistema.",
        validityPeriodSuccses: "Período de vigência salvo com sucesso.",
        lockPeriod: "Período de bloqueio",
        lockPeriodSuccses: "Período de bloqueio salvo com sucesso.",
        setPeriod: "Definir período",
        // ManagePermission
        managePermissionTitle: "Gerenciar Permissões",
        managePermissionSubtitle:
            "Use esse espaço para adicionar ou remover colaboradores que podem fazer a gestão das tarefas.",
        managePermissionLabel:
            "Selecione qual tarefa deseja atribuir ou remover permissões dos usuários abaixo",
        managePermissionPlaceholder: "Gestão de Tarefas",
        managePermissionSelectUser:
            "Selecione o usuário responsável pelas aprovações",
        managePermissionLeftTableTitle: "Usuário disponível",
        managePermissionRigthTableTitle: "Usuário atribuído",
        // ModalSaveHoliday - e6ff
        e6ff_TitleInclude: "Incluir feriado",
        e6ff_TitleEdit: "Editar parâmetro",
        e6ff_LabelType: "Selecione o tipo de recesso",
        e6ff_LabelName: "Nome do recesso",
        e6ff_LabelCampus: "Selecione o campus",
        e6ff_LabelDescription: "Motivo do recesso",
        e6ff_BtnSubmit: "Salvar",
        e6ff_BtnCancel: "Cancelar",
        e6ff_DialogSuccessTitle: "Parâmetro incluído",
        e6ff_DialogQuestionTitle: "Deseja descartar a inclusão?",
        e6ff_DialogQuestionSubtitle:
            "As informações excluídas não serão salvas.",
        e6ff_DialogQuestionBtnConfirm: "Descartar",
        e6ff_DialogQuestionBtnCancel: "Cancelar",
    },
};

const ptBrDatepickerTranslations = {
    firstDayOfWeek: 1,
    dayNames: [
        "Domingo",
        "Segunda",
        "Terça",
        "Quarta",
        "Quinta",
        "Sexta",
        "Sábado",
    ],
    dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
    dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S"],
    monthNames: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
    ],
    monthNamesShort: [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez",
    ],
    today: "Hoje",
    clear: "Limpar",
};

export { ptBrTranslations, ptBrDatepickerTranslations };
